export const formatPrice = (price: string | number): string =>
  `${price}&#8202;₽`;
